module.exports = __webpack_public_path__ + "img/mail.4f30d17b.svg";